import axios from '../../utils/axios2';
export default {
    namespaced: true,

    state: {
        driver: null,
        drivers: [],
        total: 0,
        driversLoading: false
    },

    mutations: {
        setDriver(state, payload) {
            state.driver = payload;
        },
        setDrivers(state, payload) {
            state.drivers = payload;
        },
        restDrivers(state) {
            state.drivers = [];
        },
        setTotal(state, payload) {
            state.total = payload
        },
        setDriversLoading(state, payload) {
            state.driversLoading = payload;
        }
    },
    actions: {
        storeDriver({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: "drivers",
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            });
        },
        updateDriver({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: 'put',
                    url: `drivers/${payload.id}`,
                    data: payload.form,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            });
        },
        removeDriver({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `drivers/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            });
        },
        fetchDrivers({commit, rootState}, payload) {
            commit("setDriversLoading", true)
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `drivers`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`},
                    params: payload
                })
                .then((response) => {
                    commit("setDrivers", response.data.data);
                    commit("setTotal", response.data.total);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                }).finally(() => {
                    commit("setDriversLoading", false)
                })
            }); 
        },
        fetchDriver({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `drivers/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    commit("setDriver", response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            }); 
        },
        restDrivers({commit}) {
            commit('restDrivers');
        }
    }
}